<script setup>
import Footer from '@/components/Footer.vue';
import BlockChirp from '@/components/BlockChirp.vue';
import { onMounted } from 'vue';

onMounted(async () => {
  document.title = "Thanks from Edoki Montessori Preschool";
});
</script>

<template>
  <div class="app-layout jungle-layout">
    <BlockChirp />
    <Footer :logo-path="'Chirp/OwlkidsLogo.svg'" :hide-lng-picker="true" class="chirp-footer" />
  </div>
</template>

<style>
.chirp-footer>.footer__logo>img {
  height: 5rem;
}
</style>